// extracted by mini-css-extract-plugin
export default {"link":"CountdownTimer_link__5DgmA","active":"CountdownTimer_active__x9QGb"};